import React, { useState, useEffect } from "react";

const SubscriptionStatus = () => {
  const [subscription, setSubscription] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Replace with actual values from your app state / database
  const CUSTOMER_ID = "cus_YOUR_CUSTOMER_ID"; // From your logged-in user
  const SUBSCRIPTION_ID = "sub_YOUR_SUBSCRIPTION_ID"; // From your DB

  // Load user's subscription status and cards on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        // You might have an endpoint to get subscription details
        // For simplicity, assume you store sub ID and fetch cards
        const pmRes = await fetch(
          "http://localhost:4242/list-payment-methods",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ customerId: CUSTOMER_ID }),
          }
        );
        const pmData = await pmRes.json();
        setPaymentMethods(pmData.paymentMethods);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [CUSTOMER_ID]);

  const handleCancelSubscription = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("http://localhost:4242/cancel-subscription", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subscriptionId: SUBSCRIPTION_ID }),
      });

      const data = await res.json();

      if (data.success) {
        setMessage("Subscription canceled successfully.");
        // Update UI: setSubscription(null) or refresh
      } else {
        setMessage("Failed to cancel.");
      }
    } catch (err) {
      setMessage("Error canceling subscription.");
    }

    setLoading(false);
  };

  const handleRemoveCard = async (paymentMethodId) => {
    setLoading(true);

    try {
      const res = await fetch("http://localhost:4242/remove-card", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paymentMethodId }),
      });

      const data = await res.json();

      if (data.success) {
        setPaymentMethods((prev) =>
          prev.filter((pm) => pm.id !== paymentMethodId)
        );
        setMessage("Card removed successfully.");
      }
    } catch (err) {
      setMessage("Failed to remove card.");
    }

    setLoading(false);
  };

  return (
    <div>
      <h2>Account Management</h2>

      {message && <p style={{ color: "green" }}>{message}</p>}

      <section>
        <h3>Subscription</h3>
        {SUBSCRIPTION_ID ? (
          <div>
            <p>Status: Active</p>
            <button onClick={handleCancelSubscription} disabled={loading}>
              {loading ? "Processing..." : "Cancel Subscription"}
            </button>
            <small>
              {" "}
              (You’ll keep access until the end of the current billing period)
            </small>
          </div>
        ) : (
          <p>No active subscription</p>
        )}
      </section>

      <section style={{ marginTop: "30px" }}>
        <h3>Saved Cards</h3>
        {paymentMethods.length === 0 ? (
          <p>No saved cards</p>
        ) : (
          <ul>
            {paymentMethods.map((pm) => (
              <li key={pm.id} style={{ marginBottom: "10px" }}>
                <strong>{pm.card.brand.toUpperCase()}</strong> ••••{" "}
                {pm.card.last4}
                <br />
                Expires {pm.card.exp_month}/{pm.card.exp_year}
                <button
                  onClick={() => handleRemoveCard(pm.id)}
                  style={{ marginLeft: "10px", color: "red" }}
                  disabled={loading}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};

export default SubscriptionStatus;
